import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import Home from "./component/page/home";
import TermsPage from "./component/page/TermsPage";
import PrivacyPolicyPage from "./component/page/PrivacyPolicyPage";

const container = document.getElementById("app");
const root = createRoot(container)
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/legal/terms" element={<TermsPage />} />
      <Route path="/legal/privacy" element={<PrivacyPolicyPage />} />
    </Routes>
  </BrowserRouter>
);